var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.list},[(_vm.$slots.header)?_c('div',[_vm._t("header")],2):_vm._e(),_c('div',{class:_vm.$style.body},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }